/**
 * 单据管理
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/07      1.0     First version
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */

import React from 'react';
import {Spin, Select,message ,Button} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import ShipperManagementAction from "../../ShipperManagement.action";
import Lang from "@/components/Lang/Lang";
import PriceListEdit from './PriceListEdit'
import Freight from './Freight';
import CommonPage from './common/CommonPage'
import FreightRemittanceEdit from './FreightRemittanceEdit';
import CustomsLetterEdit from './CustomsLetterEdit';
import GoodsListAndSubEdit from './GoodsListAndSubEdit'
import "./Bill.less";
import {getDownUrl} from "./common/common";

const { Option } = Select;
export default class BillIndex extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            edit:false,
            containerCode:'',
            containerId: '',
            orderType:'load',
            selectOption: [
                {code:'load',id: 'ZhuangXiangDan', title: '装箱单',statusName:'conLoadContainerOrderStatus'},
                // {code:'load_sub',id: 'YangPinZhuangXiangDan', title: '样品装箱单',statusName:'conLoadContainerSubOrderStatus'},
                {code:'trucking',id: 'SuiCheDan', title: '随车单',statusName:'conTruckingOrderStatus'},
                // {code:'trucking_sub',id: 'YangPinSuiCheDan', title: '样品随车单',statusName:'conTruckingSubOrderStatus'},
                {code:'freight',id: 'YunFeiDan', title: '运费单',statusName:'conFreightOrderStatus'},
                {code:'freight_pay',id: 'YunFeiHuiKuanDan', title: '运费汇款单',statusName:'conFreightPayOrderStatus'},
                {code:'letter',id: 'HaiGuanXinHan', title: '海关信函',statusName:'conCustomsLetterStatus'},
                {code:'price',id: 'JiaGeBiao', title: '价格表',statusName:'conPriceOrderStatus'},
                {code:'goods',id: 'ShangPinBiao', title: '商品表',statusName:'conGoodsOrderStatus'},
                // {code:'goods_sub',id: 'YangPinShangPinBiao', title: '样品商品表',statusName:'conGoodsSubOrderStatus'},
            ],
            orderInfo:{},
            statuInfo:{},//所有单据状态
        }

    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 查看各个报表状态
     * * */
    getDetailStatus(sId){
        this.loading(true);
        const postData = {
            containerId:sId,
        }
        ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/queryConReportOrderStatus').then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    /**
     * 设置 信息
     * */
    handleRes(res,){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                statuInfo:res.model||{},
            })
        }else{
            if(res.message){
                message.warning(res.message);
            }
        }
    }
    getId(){
        let {pathname} = this.props.location;
        let list = pathname.split("/")
        const containerId = list[list.length-1];
        this.setState({
            containerId: containerId
        })
        this.getDetailStatus(containerId)
    }
    handleChange(txt,containerId){
        this.setState({
            orderType: txt
        })
        this.getDetailStatus(containerId)
        // if(this.onRefPackingList)this.onRefPackingList.changeType(txt)
    }
    // refChildPacking = (ref) => this.onRefPackingList = ref;
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        if(res&&res.model&&res.model.orderInfo){
            const data = res.model.orderInfo||{}
            this.setState({
                containerCode:data.containerCode,
                orderInfo:data
            })
        }
    }
    /**
     * 编辑
     * */
    handleEdit(flag){
        this.setState({
            edit: flag
        })
    }
    
    /**
     * 处理 ATK 编码下载
     */
    handleATKCodeDownload(){
        const { containerId } = this.state;
        if(!containerId){
            message.warning(Lang({id:"QingShuRuContainerId",default:"请输入容器ID"}));
            return;
        }
        
        this.loading(true);
        const postData = {
            containerId: containerId,
        };
        
        ShipperManagementAction.autoFetchAction(postData, '/service/mg/con/report/download/atk-code-excel')
            .then(res => {
                this.loading(false);
                const { success, valid, model } = res.data;
                if (success && valid && model && model.fileUrl) {
                    // 打开文件下载链接
                    window.open(model.fileUrl, '_blank');
                } else {
                    message.warning(res.data.message || Lang({id:"XiazaiShiBai",default:"下载失败"}));
                }
            })
            .catch(err => {
                this.loading(false);
                message.warning(Lang({id:"XiazaiShiBai",default:"下载失败"}));
            });
    }
    getEditName(orderType){
        let title = '';
        switch (orderType) {
            // case 'load': //装箱单
            //     url = '/service/mg/con/report/confirm/loadContainerOrder';
            //     break;
            // case 'trucking'://随车单
            //     url = '/service/mg/con/report/confirm/truckingOrder';
            //     break;
            // case 'freight'://运费单
            //     url = '/service/mg/con/report/freight-order/confirm';
            //     break;
            case 'freight_pay'://付款单确认
                title =  Lang({id: "BianJiYunFeiHuiKuanDan",default: "编辑运费汇款单"});
                break;
            case 'letter'://海关信函
                title =  Lang({id: "BianJiHaiGuanXinHan",default: "编辑海关信函"});
                break;
            case 'price'://价格表
                title =  Lang({id: "BianJiJiaGeBiao",default: "编辑价格表"});
                break;
            case 'goods'://商品表
                title =  Lang({id: "BianJiShangPinBiao",default: "编辑商品表"});
                break;
            // case 'load_sub'://样品装箱单
            //     url = '/service/mg/con/report/confirm/loadContainerSubOrder';
            //     break;
            // case 'trucking_sub'://样品随车单
            //     url = '/service/mg/con/report/confirm/truckingSubOrder';
            //     break;
            case 'goods_sub'://样品商品表
                title =  Lang({id: "BianJiYangPinShangPinBiao",default: "编辑样品商品表"});
                break;
        }
        return title;
    }
    componentDidMount() {
        this.getId();
    }

    render(){
        const { loading,selectOption, containerId,orderType,containerCode,edit,statuInfo,orderInfo } = this.state;
        const currPageName = Lang({id: "YiChuHuoDingDan",default: "已出货订单"});
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb
                list={[
                    {name:currPageName,link:'/shipperManagement/shippingOrder/list'},
                    {name:Lang({id: "YiChuHuoDingDanXiangQing ",default: "已出货订单详情"}),link:`/shipperManagement/shippingOrder/detail?${this.state.containerId}`},
                    {name:Lang({id: "DanJuGuanLi",default: "单据管理"})}
                ]}></CommonBreadcrumb>
            <div className="bill-wrap">
                {
                    edit?
                    <div className={"font-18"} style={{marginBottom:'16px'}}>
                        {this.getEditName(orderType)}
                        {
                            containerCode&&
                            <span className={"titleSpan"}>
                                ({containerCode})
                            </span>
                        }
                    </div>
                    :
                    <div style={{marginBottom:'16px'}}>
                        <div>{containerCode&&<span className={"titleSpan"}>{containerCode}</span>}</div>
                        {/*<Select defaultValue={orderType} style={{ minWidth: 300 }} onChange={(txt)=>this.handleChange(txt,containerId)}>
                            {selectOption.map(item=><Option value={item.code} key={item.code}>
                                {statuInfo[item.statusName]=='10'&&<span className="margin-right-5 icon iconfont icon-waring font-main"></span>}
                                {statuInfo[item.statusName]=='20'&&<span className="margin-right-5 icon iconfont icon-a-Frame1892 font-green"></span>}
                                {Lang({id:item.id,default:item.title})}
                            </Option>)}
                        </Select>*/}

                        <div className="select-btn__wrap">
                            {
                                selectOption.map((item,index)=>{
                                    return <Button className={orderType==item.code?'active':''} key={index} onClick={()=>this.handleChange(item.code,containerId)}>
                                        {statuInfo[item.statusName]=='10'&&<i className="margin-right-5 ri-todo-line" style={{color:'#CE5650'}}></i>}
                                        {statuInfo[item.statusName]=='20'&&<i className="margin-right-5 ri-checkbox-multiple-line" style={{color:'#1EB071'}}></i>}
                                        {Lang({id:item.id,default:item.title})}
                                    </Button>
                                })
                            }
                            {
                                statuInfo.isCanDownloadAtkCode?
                                    <Button onClick={()=>this.handleATKCodeDownload()}>ATK编码</Button>
                                    :
                                    null
                            }
                        </div>
                    </div>
                }

                {/* load:装箱单 trucking:随车单 */}
                {containerId&&orderType&&<>
                {orderType=='load'&&<CommonPage orderType={orderType} containerId={containerId}
                                                                        scroll={{x:4500}}
                                                                        downloadUrlExcel={getDownUrl(orderType,1)}
                                                                        downloadUrlPdf={getDownUrl(orderType,2)}
                                                                        pageTitle={Lang({id: 'ZhuangXiangDan', default: '装箱单'})}
                                                                        fetchApi={'/service/mg/con/report/loadContainer/list'}
                                                                        fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {orderType=='trucking'&&<CommonPage orderType={orderType} containerId={containerId}
                                                    scroll={{x:1700}}
                                                                            pageTitle={Lang({id: 'SuiCheDan', default: '随车单'})}
                                                                            downloadUrlExcel={getDownUrl(orderType,1)}
                                                                            downloadUrlPdf={getDownUrl(orderType,2)}
                                                                            fetchApi={'/service/mg/con/report/truckingOrder/list'}
                                                                            fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* load_sub: 样品装箱单 */}
                {orderType=='load_sub'&&<CommonPage orderType={orderType} containerId={containerId}
                                                                            scroll={{x:4500}}
                                                                            pageTitle={Lang({id: 'YangPinZhuangXiangDan', default: '样品装箱单'})}
                                                                            downloadUrlExcel={'/service/mg/con/report/download/loadContainerSubOrderExcel'}
                                                                            downloadUrlPdf={'/service/mg/con/report/download/loadContainerSubOrderPDF'}
                                                                            fetchApi={'/service/mg/con/report/loadContainerSub/list'}
                                                                            fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* trucking_sub:样品随车单 */}
                {orderType=='trucking_sub'&&<CommonPage orderType={orderType} containerId={containerId}
                                                        scroll={{x:1700}}
                                                                                pageTitle={Lang({id: 'YangPinSuiCheDan', default: '样品随车单'})}
                                                                                fetchApi={'/service/mg/con/report/truckingSubOrder/list'}
                                                                                downloadUrlExcel={'/service/mg/con/report/download/truckingSubOrderExcel'}
                                                                                downloadUrlPdf={'/service/mg/con/report/download/truckingSubOrderPDF'}
                                                                                fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* freight:运费单 */}
                {orderType=='freight'&&<Freight orderType={orderType} containerId={containerId}
                                                downloadUrlExcel={'/service/mg/con/report/download/freightOrderExcel'}
                                                downloadUrlPdf={'/service/mg/con/report/download/freightOrderPDF'}
                                                fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* freight_pay:运费付款表 */}
                {orderType=='freight_pay'&&<FreightRemittanceEdit orderType={orderType} containerId={containerId}
                                                                  handleEdit={(flag)=>this.handleEdit(flag)}
                                                                  downloadUrlExcel={'/service/mg/con/report/download/freightPayOrderExcel'}
                                                                  downloadUrlPdf={'/service/mg/con/report/download/freightPayOrderPDF'}
                                                                  fetchCallBack={(res)=>this.setOrderInfo(res)} />}

                {/* letter:海关信函 */}
                {orderType=='letter'&&<CustomsLetterEdit orderType={orderType} containerId={containerId}
                                                         handleEdit={(flag)=>this.handleEdit(flag)}
                                                         downloadUrlPdf={'/service/mg/con/report/download/customsLetterPDF'}
                                                         fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* price:价格表 */}
                {orderType=='price'&&<PriceListEdit orderType={orderType} containerId={containerId}
                                                    handleEdit={(flag)=>this.handleEdit(flag)}
                                                   orderInfo={orderInfo}
                                                    downloadUrlExcel={'/service/mg/con/report/download/priceOrderExcel'}
                                                    downloadUrlPdf={'/service/mg/con/report/download/priceOrderPDF'}
                                                    fetchCallBack={(res)=>this.setOrderInfo(res)} />}
                {/* goods:商品表 */}
                {orderType=='goods'&&<GoodsListAndSubEdit orderType={orderType} containerId={containerId}
                                                          handleEdit={(flag)=>this.handleEdit(flag)}
                                                          pageTitle = {Lang({id: 'ShangPinBiao', default: '商品表'})}
                                                          callBackFields = {['model','goodsOrderList']}
                                                          fetchApi={' /service/mg/con/report/goods-order/details'}
                                                          saveApi={'/service/mg/con/report/goods-order/save'}
                                                          downloadUrlExcel={'/service/mg/con/report/download/goodsOrderExcel'}
                                                          downloadUrlPdf={'/service/mg/con/report/download/goodsOrderPDF'}
                                                          fetchCallBack={(res)=>this.setOrderInfo(res)} />}

                {/* goods_sub:样品商品表 todo 内容 */}
                {orderType=='goods_sub'&&<GoodsListAndSubEdit orderType={orderType} containerId={containerId}
                                                              handleEdit={(flag)=>this.handleEdit(flag)}
                                                              pageTitle = {Lang({id: 'YangPinShangPinBiao', default: '样品商品表'})}
                                                              callBackFields = {['model','goodsSubOrderItemList']}
                                                              fetchApi={'/service/mg/con/report/goods-sub-order/details'}
                                                              saveApi={'/service/mg/con/report/goods-sub-order/save'} //todo 待确认
                                                              downloadUrlExcel={'/service/mg/con/report/download/goodsSubOrderExcel'}
                                                              downloadUrlPdf={'/service/mg/con/report/download/goodsSubOrderPDF'}
                                                              fetchCallBack={(res)=>this.setOrderInfo(res)} />}

                </>}
            </div>
        </Spin>)
    }
}
